import styled from 'styled-components';

import { H4styles } from '~/src/common/components/Typography';
import { media } from '~/src/styles-constants';

export const Container = styled.div`
  position: relative;

  margin-bottom: 32px;

  & > div,
  & > span > span {
    font-family: ${({ theme }) => theme.fonts.primary};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Header = styled.h2`
  ${H4styles}
  display: flex;
  align-items: center;
  margin: 0;
  scroll-margin-top: 48px;

  ${media.M`
    margin-bottom: 8px;
  `}

  ${media.XL`
    scroll-margin-top: 176px;
  `}
`;

export const Description = styled.span`
  display: inline-block;

  font-size: 14px;
  line-height: 20px;

  & p {
    font-size: 14px;
    line-height: 20px;
  }

  & p:last-child {
    margin-bottom: 0;
  }
`;
